import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "@/services/axiosAuth";
import { INCIDENT_TYPE_API } from "./apiRoutes";

interface UseGetActiveIncidentTypesProps {
  communityId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getActiveIncidentTypes = async (communityId: string) =>
  await axiosAuth.get(`${INCIDENT_TYPE_API(communityId)}/active`);

const useGetActiveIncidentTypes = ({
  communityId,
  queryParams,
}: UseGetActiveIncidentTypesProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["incident-active-types", communityId],
    queryFn: () => getActiveIncidentTypes(communityId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetActiveIncidentTypes;
